<template lang="pug">
a
  button(@click="openBuy(product, coupon)" :class="classes") {{ copy }}
</template>

<script>
import EventBus from '../eventBus.js';
import router from '../router';

export default {
  name: 'Buy-button',
  props: {
    classes: String,
    product: String,
    copy: String,
    coupon: String,
  },
  data() {
    return {
      userAccount: {},
      userPlan: '',
    };
  },
  created() {
    const self = this;
    this.userAccount = JSON.parse(localStorage.getItem('account'));
    if (this.userAccount) {
      this.userPlan = this.userAccount.subscription.plan;
    }
    EventBus.$on('1DollarBuy', function () {
      self.openBuy('fmp-m', '1DOLLARDEAL');
    });
  },
  methods: {
    openBuy(product, coupon) {
      if (this.userAccount) {
        if (this.userPlan === 'free') {
          // Start purchase
          EventBus.$emit('showButtonBuyModal', product, coupon);
        } else {
          // Go to account page
          router.push({ name: 'Settings' });
        }
      } else {
        // Start purchase
        EventBus.$emit('showButtonBuyModal', product, coupon);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/buyButton.vue